export default {
  computed: {
    toursQuickFilters() {
      return {
        title: 'Tours',
        filters: {
          columns: [
            {
              class: 'col-12 col-lg-2',
              filters: [
                {
                  name: 'status',
                  label: this.$gettext('Statuses'),
                  type: 'checkbox-group',
                  options: [
                    'DRAFT',
                    'READY',
                    'INTRANSIT',
                    'FINISHED',
                    'CANCELED'
                  ],
                  value: [],
                  stacked: true,
                  callback: (val) => {
                    if (val.length > 0) {
                      return [['status', 'in', val]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-lg-5',
              filters: [
                {
                  name: 'tour-id',
                  label: this.$gettext('Tour ID'),
                  type: 'textarea',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      let ids
                      if (val.indexOf('\n') !== -1) {
                        ids = val.split('\n')
                        return [['id', 'in', ids]]
                      } else {
                        const ids = val.split(',')
                        return [['id', 'in', ids]]
                      }
                    } else {
                      return []
                    }
                  }
                },
                {
                  columns: [
                    {
                      class: 'col-12 col-lg-6',
                      filters: [
                        {
                          name: 'tour-created-at',
                          label: this.$gettext('Created At Date Range'),
                          type: 'daterange',
                          opens: 'right',
                          locale: {
                            format: this.$gettext('mm/dd/yyyy')
                          },
                          value: {
                            startDate: this.moment().toDate(),
                            endDate: this.moment().toDate(),
                            dateRangeActive: false
                          },
                          callback: (val) => {
                            if (val.dateRangeActive) {
                              const range = [
                                this.moment.tz(val.startDate, this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                                this.moment.tz(val.endDate, this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                              ]
                              return [['created_at', 'bt', range]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    },
                    {
                      class: 'col-12 col-lg-6',
                      filters: [
                        {
                          name: 'tour-updated-at',
                          label: this.$gettext('Updated At Date Range'),
                          type: 'daterange',
                          opens: 'center',
                          locale: {
                            format: this.$gettext('mm/dd/yyyy')
                          },
                          value: {
                            startDate: this.moment().subtract(14, 'days').toDate(),
                            endDate: this.moment().toDate(),
                            dateRangeActive: true
                          },
                          callback: (val) => {
                            if (val.dateRangeActive) {
                              const range = [
                                this.moment.tz(val.startDate, this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                                this.moment.tz(val.endDate, this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                              ]
                              return [['updated_at', 'bt', range]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              class: 'col-12 col-lg-5',
              filters: [
                {
                  name: 'tour-courier',
                  label: ' ',
                  type: 'user-autocomplete',
                  restrictToRoles: ['courier'],
                  placeholder: this.$gettext('Courier name or email'),
                  value: [],
                  props: {
                    endpoint: 'companies/users'
                  },
                  callback: (val) => {
                    if (val.length > 0) {
                      const couriers = val.map(function (item) {
                        return item.id
                      })
                      return [['courier_id', 'in', couriers]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'with-courier',
                  label: this.$gettext('Without courier assigned'),
                  type: 'checkbox',
                  value: false,
                  callback: (val) => {
                    if (val) {
                      return [['courier_id', 'eq', null]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
